/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenderResponseModel } from '../../models/tender-response-model';

export interface GetTender$Params {
  tenderId: string;
}

export function getTender(http: HttpClient, rootUrl: string, params: GetTender$Params, context?: HttpContext): Observable<StrictHttpResponse<TenderResponseModel>> {
  const rb = new RequestBuilder(rootUrl, getTender.PATH, 'get');
  if (params) {
    rb.path('tenderId', params.tenderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenderResponseModel>;
    })
  );
}

getTender.PATH = '/tenders/{tenderId}';
